export const large = '@media (min-width: 1200px)'
export const medium = '@media (min-width: 768px) and (max-width: 1200px)'
export const small = '@media (max-width: 768px)'
export const extraSmall = '@media (max-width: 576px)'
